import styled from "styled-components/macro";

export const Container = styled.div(() => ({
  display: "flex",
  flexWrap: "nowrap",
  alignItems: "center",
  justifyContent: "space-around",
  backgroundColor: "white",
  boxShadow: "0px 2px 7px 3px rgb(220,220,220);",
  width: "100%",
  height: "80px!important",
  borderStyle: "hidden",
  borderRadius: "30px",
  overflow: "hidden",
  marginBottom: "20px",
  marginTop: "20px",
}));

export const Link = styled.a(() => ({
  width: "100%",
  height: "80px",
  fontSize: "1.1rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textDecoration: "none",
  color: "#005FC8",
  fontWeight: 700,
  "&:hover": {
    textDecoration: "none",
    borderStyle: "hidden",
    borderRadius: "30px",
    backgroundColor: "#0065b7",
    color: "white",
  },
}));
